/**
 * String replacements for manifest shaders.
 * Lookup by set id and shader key.
 */
export const shaderOverrides: Record<
  string,
  Record<
    string,
    { searchValue: string; replaceValue: string; replaceAll?: boolean }[]
  >
> = {
  // Archmage's Favor
  "00501": {
    magic: [
      {
        // reduces the intensity of the color mix
        searchValue: "vec3 color = mix(color1,color2,(col + col2)*2.0);",
        replaceValue: "vec3 color = mix(color1,color2,(col + col2)*1.5);",
      },
      {
        // add u_UpAxis to account for preview / rolling canvas
        searchValue: "uniform float iGlobalTime;",
        replaceValue: `
          uniform float iGlobalTime;
          uniform vec3 u_UpAxis;
        `,
      },
      {
        // add vWorldPosition from our vertex shader
        searchValue: "varying vec3 vViewPosition;",
        replaceValue: `
          varying vec3 vViewPosition;
          varying vec3 vWorldPosition;
        `,
      },
      {
        // the d4 highlight doesn't even work in OG dice - this fixes it!
        searchValue: "add = vViewPosition.y > 2.0 ? 1.0 : 0.0;",
        replaceValue: `
          float heightAlongUp = dot(normalize(u_UpAxis), vWorldPosition);
          if (heightAlongUp > 0.75) {
            add = 1.0;
          }
        `,
      },
    ],
  },
};
